<template>
    <div class="customer-purchased-items-container">
      <b-row class="my-4">
        <b-col class="d-flex">
          <span># of Items: {{ items.length }}</span>
          <span class="px-4">Total Price: <span class="price">${{ totalPrice }}</span></span>
          <span>Total Last Sold Price: <span class="price">${{ totalLastSoldPrice }}</span></span>
        </b-col>
      </b-row>
      <div class="scrollable-container">
        <b-table
          primary-key="details.itemId + '_' + item._id"
          sticky-header
          small
          no-border-collapse
          @row-selected="rowSelected"
          class="inventory-table"
          :items="items"
          :fields="fields"
          :busy.sync="isBusy"
          ref="customerPurchasedItemsTable"
          id="customerPurchasedItemsTable"
          caption-top
        >

        <template #cell(itemId)="row">
          <b-link :to="{ name: 'itemDetails', params: { outsideQuery: { query: row.item.details.itemId.toString(), filters: {} } } }">
            {{ row.item.details.itemId }}
          </b-link>
        </template>

        <template #cell(artist)="row">
          <span v-html="artistData(row)"></span>
        </template>

        <template #cell(title)="data">
            <span v-html="titleData(data)"></span>
        </template>

        <template #cell(label)="data">
            <span v-html="labelData(data)"></span>
        </template>

        <template #cell(genre)="data">
            <ul class="p-0 d-flex flex-column">
                <li class="cellListItem list-unstyled" v-for='(genre, index) in data.item.details.release.genres' :key='index'>
                {{genre.name}}
                </li>
            </ul>
        </template>

        <template #cell(format)="data">
            <span v-html="format(data)"></span>
        </template>

        <template #cell(quantity)="data">
            <span class='d-flex'>{{ data.item.details.quantity }}</span>
        </template>

        <template #cell(price)="data">
            <span class='d-flex price'>${{ data.item.details.listing.price }}</span>
        </template>

        <template #cell(lastSoldPrice)="data">
            <span class='d-flex price'>${{ data.item.lastSoldPrice }}</span>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
          </div>
        </template>
  
        </b-table>
      </div>
    </div>
  </template>
  
  <script>
  import searchMixin from "../../mixins/search";
  import inventoryApi from "../../api/inventory";
  import customerApi from "../../api/customers";
  import utils from "../../mixins/utils";
  import moment from "moment";
  
  export default {
    name: "CustomerInventory",
    mixins: [searchMixin, inventoryApi, customerApi, utils],
    props: ['customerId', "email"],

    async mounted() {
      await this.fetchPurchasedItems();
    },
    data() {
      return {
        searchResults: {},
        items: [],
        numItems: 0,
        isBusy: false,
        fields: [
          { key: 'itemId', label: 'Item' },
          { key: 'artist', label: 'Artist' },
          { key: 'title', label: 'Title' },
          { key: 'label', label: 'Label' },
          { key: 'genre', label: 'Genre' },
          { key: 'format', label: 'Format' },

          { key: 'orderDate', label: 'Order Date', 
            formatter: date => {
              if (date) {
                  return moment(date).format('M/D/YYYY h:mma');
              }
              return '';
            }, 
          },
          {key: 'quantity', label: '#'},
          { key: 'price', label: '$' },
          { key: 'lastSoldDate', label: 'Last Sold Date', 
            formatter: date => {
              if (date) {
                  return moment(date).format('M/D/YYYY h:mma');
              }

              return '';
            }, 
          },
          { key: 'lastSoldPrice', label: 'Last Sold Price' }
        ],
        numOrders: 0,
      };
    },
    computed: {
      totalPrice() {
        return this.items.reduce((sum, item) => {
          const quantity = item.details.quantity || 0;
          const price = item.details.listing.price || 0;
          return sum + (price * quantity);
        }, 0).toFixed(2);
      },
      totalLastSoldPrice() {
        return this.items.reduce((sum, item) => {
          const quantity = item.details.quantity || 0;
          const lastSoldPrice = item.lastSoldPrice || 0;
          return sum + (lastSoldPrice * quantity);
        }, 0).toFixed(2);
      }
    },
    methods: {
      async fetchPurchasedItems() {
        try {
          this.isBusy = true;
          const fetchedItems = await this.getInventoryOrderedByCustomerId(this.customerId);
          this.items = fetchedItems;
        } catch (error) {
          console.error('Error fetching purchased items:', error);
          // Handle the error, e.g., show an error message to the user
        } finally {
          this.isBusy = false;
        }
      },
  
      rowSelected(rows) {
        this.selected = rows;
      },
      updateNumOrders(num) {
        this.numOrders = num;
      },
      artistData(data) {
            return `${this.artist(data.item)}`;
        },
      titleData(data) {
        if (data && data.item.details.release.titles && data.item.details.release.titles.length > 0) {
          return `${this.title(data)}`;
        }
        return '';
      },
      labelData(data) {
        if (data && data.item.details.release.label) {
          return `${data.item.details.release.label.name} ${data.item.details.release.label.catalogNo || ''}`;
        }
        return '';
      },
      pressingData(data) {
        return data ? data.map(p => p.text).join(', ') : '';
      },
      mediaData(data) {
        return data ? data.map(media => media.duration).join(', ') : '';
      },
        gradeData(conditionArray) {
            if (conditionArray.length < 1) return '';
            const sortOrder = ["item", "disc", "cassette", "cover", "case", "label", "insert"];
            const sortedArray = conditionArray.slice().sort((a, b) => sortOrder.indexOf(a.subject) - sortOrder.indexOf(b.subject));
            return sortedArray.map(condition => {return condition.grade}).join(', ');
        },
        format(data, separator = ' ') {
            if (!data.item.details.release.media.length || !data.item.details.release.media[0].size) {
                return ``;
            }

            if (data.item.details.release.media[0].size === '12') {
                if (data.item.details.release.media[0].duration === 'Single') {
                    return '12'
                } else if (data.item.details.release.media[0].duration === 'LP') {
                    return 'LP';
                } else {
                    return data.item.details.release.media[0].duration;
                }
            } else if (data.item.details.release.media[0].size === '10') {
                if (data.item.details.release.media[0].speed === '78') {
                    return '78';
                }
                return '10';
            } else if (data.item.details.release.media[0].size === '7') {
                if (data.item.details.release.media[0].duration === 'EP') {
                    return 'EP'
                } else {
                    return '45';
                }
            } else if (data.item.details.release.media[0].size === '5') {
                return 'CD';
            } else if (data.item.details.release.media[0].size === '4') {
                return 'Cassette';
            }

            if (data.item.details.release.media.length) {
                let size = data.item.release.media[0].size;
                let count = data.item.release.media[0].count;

                if (count > 1) {
                    size = `${count}x${size}`;
                }

                let format = `${size}" ${data.item.release.media[0].duration}`;

                format += separator;

                if (data.item.release.media[1]) {
                    format += `...`;
                }

                return format;
            }
        },
        artist(data) {
            if (!data || !data.details || !data.details.release || !data.details.release.artist) {
                return ``;
            }

            if (data.details.release.artist.first) {
                return `${data.details.release.artist.first} ${data.details.release.artist.last}`.trim();
            }

            return `${data.details.release.artist.last}`.trim();
        },
        title(data) {
            if (data.item.details.release.titles && data.item.details.release.titles[0] && data.item.details.release.titles[1]) {
                return `${data.item.details.release.titles[0]} / ${data.item.details.release.titles[1]}`;
            }

            return data.item.details.release.titles[0] || '';
        },
        label(data) {
            if (data.item.release.label && data.item.release.label.name) {
                return `${data.item.release.label.name}`;
            }

            return '';
        },
        catalogNo(data) {
            if (data.item.release.label && data.item.release.label.catalogNo) {
                return `${data.item.release.label.catalogNo}`;
            }

            return '';
        },
    }
  };
  </script>
  
  <style scoped>
  .inventory-table {
    max-height: calc(100% - 20px);
    box-sizing: border-box;
  }

  .price { 
    color: #28a745;
  }
  
  .customer-purchased-items-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 200px);
    box-sizing: border-box;
  }
  
  .scrollable-container {
    overflow: auto;
    flex-grow: 1;
  }
  
  .cellListItem {
    width: max-content;
    padding-right: 10px;
  }
  </style>
  